import {FlexGridColumnGroup} from '@grapecity/wijmo.react.grid';
import Grid from '@mui/material/Grid';
// import {HttpStatusCode} from 'axios';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {getFormSyncWarnings, getFormValues, reduxForm, Field} from 'redux-form';
// import {getComboName} from '../../../../common/common.js';
// import {getSessionObject, setSessionObject} from '../../../../common/Session.js';
import {getSessionObject} from '../../../../common/Session.js';
// import {postRequest,
// putRequest
// } from '../../../../../common/backend.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {createFieldItems, createGridFields, sysErr} from '../../../../common/commonGmn.js';
import {commonOperations} from '../../../../reducks/common/index.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
import PaperPart from '../../../atoms/PaperPart.js';
// import PageTitle from '../../../../molecules/PageTitle.js';
// import FooterButton from '../../../organisms/FooterButton.js';
import MainContainer from '../../../organisms/MainContainer.js';
import withRouter from '../../../organisms/withRouter.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import Approval from '../../../molecules/Approval.js';
import {AutoComplete} from '@grapecity/wijmo.input';
import {DataMap} from '@grapecity/wijmo.grid';
// import Typography from '@mui/material/Typography';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
// import DangerButton from '../../../atoms/Buttons/DangerButton.js';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
// import SaveIcon from '@mui/icons-material/Save';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
// import BFY60101G from '../../InvestigationIndustry/Popu';
import withFormatMessage from '../../../organisms/withFormatMessage.js';
import {withMediaQuery} from '../../../atoms/withMediaQuery.js';
import Typography from '@mui/material/Typography';
import {
  FormControl,
  FormGroup,
} from '@mui/material';
import {renderCheckbox} from '../../../atoms/CustomPart.js';
// import Cancel from '@mui/icons-material/Cancel';
import Divider from '@mui/material/Divider';
// import CustomMultiRow, {createComponents} from '../../../molecules/CustomMultiRow.js';
// import GridPopup, {createPopupData} from '../../../molecules/GridPopup.js';
import ApprovalStatus from '../../../organisms/Approval/ApprovalStatus/index.js';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import SearchIcon from '@mui/icons-material/Search';
import {renderTextField, renderSelect} from '../../../atoms/CustomPart.js';
import MenuItem from '@mui/material/MenuItem';
import CustomAccordion from '../../../molecules/Accordion.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.ANNUAL_SURVERY_PLAN_LIST.name,
    href: GMN_PATH.ANNUAL_SURVERY_PLAN_LIST},
  {gmnName: GMN.ANNUAL_SURVERY_PLAN_INFO.name, href: ''},
];


// 年度計画Items
const gmnItemsNyuryo = {
  // SinseiId: {binding: 'sinseiId', label: '申請番号', required: false, type: 'text', sm: 3, readOnly: true},
  Zigyoujo: {binding: 'zigyoujo', label: 'NW事業所', required: false, type: 'text', sm: 2, readOnly: false},
  // itakuCd: {binding: 'itakuCd', label: '委託番号', required: false, type: 'text', sm: 2, readOnly: true},
  SakuseiDate: {binding: 'surveyYear', label: '年度', required: false, type: 'text', sm: 2, readOnly: false},
  tyousakikan: {binding: 'tyousakikan', label: '調査機関', required: false, type: 'text', sm: 2, readOnly: false},
  tskkJgyosyo: {binding: 'tskkJgyosyo', label: '調査機関事業所', required: false, type: 'text', sm: 2, readOnly: true},
  States: {binding: 'states', label: 'ステータス', required: false, type: 'text', sm: 2, readOnly: true},
};

// 承認ステータスItems
const gmnItemsStepApproval = {
  StepApprovalComment: {binding: 'stepApprovalComment', label: '否決コメント', required: false, type: 'text', sm: 6, variant: 'outlined', multiline: true, rows: 3, readOnly: true},
  StepApprovalDateTime: {binding: 'stepApprovalDateTime', label: '否決日', required: false, type: 'text', sm: 2, readOnly: true},
};

// 一覧
const getListViews = [
  {binding: 'nwJigyosyo', header: '旧NW事業所', dataType: 'String', width: 95, readOnly: true},
  {binding: 'blockNo', header: 'ブロック番号', dataType: 'String', width: 70, readOnly: true},
  {binding: 'daihyoZyusyo', header: '代表住所', dataType: 'String', width: 110, readOnly: true},
  {binding: 'tskkJgyosyo', header: '調査機関事業所', dataType: 'Select', width: 90, readOnly: true},
  {binding: 'userId', header: '担当者', dataType: 'Select', width: 110, readOnly: false},
  {header: '実施年月', dataType: 'header', elems: [

    {binding: 'fourYearZisiMonth', header: '４年', dataType: 'Select', width: 95, readOnly: false},
    {binding: 'ereryYearZisiMonth', header: '毎年', dataType: 'Select', width: 95, readOnly: false},
  ]},
  {binding: 'tsTkTotal', header: '総計（件）', dataType: 'Number', width: 65, readOnly: true},

  {header: '４年周期（件）', dataType: 'header', elems: [
    {binding: 'fourYearTotal', header: '小計', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'fourYearTeiGakuOther', header: '定額以外', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'fourYearTeiGaku', header: '定額', dataType: 'Number', width: 65, readOnly: true},

  ]},
  {header: '毎年調査（件）', dataType: 'header', elems: [
    {binding: 'chousaIndustry', header: '小計', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'chousaIndustry02', header: '寝老人', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'chousaIndustry03', header: 'プール', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'chousaIndustry04', header: '公衆浴場', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'chousaIndustry05', header: '学校等', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'chousaIndustry06', header: '病院等', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'chousaIndustry07', header: '老人福祉施設', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'chousaIndustry08', header: '重要文化財', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'chousaIndustry09', header: '学校・プール', dataType: 'Number', width: 65, readOnly: true},
  ]},

  {header: '点検（件）', dataType: 'header', elems: [
    {binding: 'tkGutisu', header: '小計', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'tkDotyo', header: '同調', dataType: 'Number', width: 65, readOnly: true},
    {binding: 'tkTandoku', header: '単独', dataType: 'Number', width: 65, readOnly: true},
  ]},


  // {binding: 'sinnseiStatus', header: 'ステータス', dataType: 'String', width: 110, readOnly: false},
];

const exceptFiltersBindings = [
  'ereryYearZisiMonth', 'fourYearZisiMonth', 'fourYearTotal',
  'fourYearTeiGaku', 'fourYearTeiGakuOther', 'chousaIndustry02', 'chousaIndustry03', 'chousaIndustry04', 'chousaIndustry05',
  'chousaIndustry06', 'chousaIndustry07', 'chousaIndustry08', 'chousaIndustry09', 'chousaIndustry',
  'tsTkTotal', 'tkGutisu', 'tkDotyo', 'tkTandoku',
];


// 年度計画登録(担当者)
const totalViews = [
  {binding: 'tyousakei', header: '調査箇所数（件）', type: 'text', width: 250, readOnly: false},
  {binding: 'goukei', header: '合計', type: 'text', width: 765, readOnly: false},
];

/**
 * 年度計画登録(担当者)
 * 画面ID:SCE1002
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    // 調査機関事業所
    let tskkJgyosyoList = [
      {id: '2110', name: '福山支'},
      {id: '2120', name: '府中支'},
      {id: '3550', name: '岡山東支'},

    ];
    // 担当者
    let userIdList = [
      {id: 'TB0001', name: '田中　一郎'},
      {id: 'TB0002', name: '田中　二郎'},
      {id: 'TB0003', name: '田中　三郎'},
      {id: 'TB0004', name: '田中　四郎'},
      {id: 'TB0005', name: '田中　五郎'},
    ];
    // 実施年月
    let yearMonthList = [
      {id: '1', name: '2027/04'},
      {id: '2', name: '2027/05'},
      {id: '3', name: '2027/06'},
      {id: '4', name: '2027/07'},
      {id: '5', name: '2027/08'},
      {id: '6', name: '2027/09'},
      {id: '7', name: '2027/10'},
      {id: '8', name: '2027/11'},
      {id: '9', name: '2027/12'},
      {id: '10', name: '2028/01'},
      {id: '11', name: '2028/02'},
      {id: '12', name: '2028/03'},
    ];
    // パラメータ取得
    const storage = getSessionObject(GMN.ANNUAL_SURVERY_PLAN_INFO.id);
    // TODO フロント画面の判定条件
    let mode = 0;
    let visableSnFlg = true;
    let visableSlFlg = true;
    if (storage['mod'] === 'I') {
      mode = 0;
      visableSnFlg = false;
      visableSlFlg=false;
    } else if (storage['mod'] === 'C') {
      mode = 1;
      visableSnFlg = false;
      visableSlFlg=false;
    } else if (storage['mod'] === 'S') {
      mode = 2;
      visableSnFlg = false;
      visableSlFlg=false;
    } else if (storage['mod'] === 'U') {
      mode = 3;
      visableSnFlg = true;
      visableSlFlg = false;
    } else {
      mode = 4;
      visableSnFlg = false;
      visableSlFlg = true;
    }

    this.state = {
      // 1:請求書再請求 2:承認フロー
      mode: mode,
      warningMessages: [],
      // 請求情報
      seikyuInfo: storage ?? {},
      henkoJohomaeList: [],
      seiHeaderDate: {},
      tskkJgyosyoList: tskkJgyosyoList,
      userIdList: userIdList,
      yearMonthList: yearMonthList,
      // 承認機能部表示判定条件
      visableSnFlg: visableSnFlg,
      visableSlFlg: visableSlFlg,
      buttonDisabled: true,
      listZigyojoMst: [],
      modalOpen: false,
      gamenData: {},
      gridRefErr: false,
      showApprovalModal: false,
    };
    // 一覧Ref作成
    this.gridRef = React.createRef();
    this.gridTotalRef = React.createRef();

    this.popupItems = {};  // 編集ダイアログ用
    this.items = {};    // グリッドデータ初期化
    this._gridItems = {};
    this._fields = [];
    // this.setGridItems();
    this.setInitValue();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.getInitializeData();
      return;
    } catch (error) {
      sysErr(this.props);
    }
  }

  /**
   * 初期データ検索
   */
  getInitializeData = async () => {
    let initItems = {};
    this.initializeItems(initItems);

    let henkoJohomaeList = [];
    // let totalList = [];
    let data = {};

    if (this.state.mode !== 0) {
      henkoJohomaeList = [
        {nwJigyosyo: '広島北', blockNo: '10001', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '福山支', userId: '田中　一郎', ereryYearZisiMonth: ' ', fourYearZisiMonth: '2027/07', tsTkTotal: '3,000', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '0', chousaIndustry02: '0', chousaIndustry03: '0', chousaIndustry04: '0', chousaIndustry05: '0', chousaIndustry06: '0', chousaIndustry07: '0', chousaIndustry08: '0', chousaIndustry09: '0', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '広島北', blockNo: '10002', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '福山支', userId: '田中　一郎', ereryYearZisiMonth: ' ', fourYearZisiMonth: '2027/07', tsTkTotal: '3,000', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '0', chousaIndustry02: '0', chousaIndustry03: '0', chousaIndustry04: '0', chousaIndustry05: '0', chousaIndustry06: '0', chousaIndustry07: '0', chousaIndustry08: '0', chousaIndustry09: '0', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '広島北', blockNo: '10003', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '福山支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '広島北', blockNo: '10004', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '福山支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '広島北', blockNo: '10005', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '福山支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '広島北', blockNo: '10006', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '福山支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '広島北', blockNo: '10007', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '福山支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '広島北', blockNo: '10008', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '福山支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '廿日市', blockNo: '10001', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '府中支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '廿日市', blockNo: '10002', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '府中支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '廿日市', blockNo: '10003', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '府中支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '廿日市', blockNo: '10004', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '府中支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '廿日市', blockNo: '10005', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '府中支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '廿日市', blockNo: '10006', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '府中支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '廿日市', blockNo: '10007', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '岡山東支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '廿日市', blockNo: '10008', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '岡山東支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '廿日市', blockNo: '10009', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '岡山東支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '廿日市', blockNo: '10010', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '岡山東支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '廿日市', blockNo: '10011', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '岡山東支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '廿日市', blockNo: '10012', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '岡山東支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '廿日市', blockNo: '10013', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '岡山東支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '廿日市', blockNo: '10014', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '岡山東支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},
        {nwJigyosyo: '廿日市', blockNo: '10015', daihyoZyusyo: '住所XXXXX', tskkJgyosyo: '岡山東支', userId: '田中　一郎', ereryYearZisiMonth: '2027/05', fourYearZisiMonth: '2027/07', tsTkTotal: '3,800', fourYearTotal: '3,000', fourYearTeiGaku: '1,000', fourYearTeiGakuOther: '2,000', chousaIndustry: '800', chousaIndustry02: '100', chousaIndustry03: '100', chousaIndustry04: '100', chousaIndustry05: '100', chousaIndustry06: '100', chousaIndustry07: '100', chousaIndustry08: '100', chousaIndustry09: '100', tkGutisu: '100', tkDotyo: '40', tkTandoku: '60'},

      ];

      // totalList=[
      //   // {itakuSaki: '調査箇所数（件）'},
      //   {tyousakei: '調査箇所数（件）：', goukei: '1,234,567  （事業者別予定件数の計との差：±-3,234）'},
      //   {tyousakei: '点検箇所数（件）：', goukei: '1,234,567  （事業者別予定件数の計との差：±-3,234）'},
      // ];

      data = {zigyoujo: '5160', surveyYear: '2027', itakuSaki: '委託１', tyousakikan: '5000', tskkJgyosyo: '4500', tdhknAddCd: '34', states: '作成中'};
    } else {
      data = {zigyoujo: '5160', surveyYear: '2027', itakuSaki: '委託１', tyousakikan: '5000', tskkJgyosyo: '4500', tdhknAddCd: '34', states: '作成中'};
    }

    // 調査理由入力情報データ設定
    for (const key of Object.keys(initItems)) {
      if (Object.hasOwn(data, key)) {
        initItems[key] = data[key];
      }
    }

    initItems['approvalComment'] = 'approvalComment';

    // 承認データを画面に設定
    this.props.doSetInitValues(initItems);

    if (this.gridRef.current) {
      // 変更前リストデータを画面に設定
      this.gridRef.current.setItemsSource(henkoJohomaeList);
    }
    // if (this.gridTotalRef.current) {
    //   // 変更前リストデータを画面に設定
    //   this.gridTotalRef.current.setItemsSource(totalList);
    // }


    let listZigyojoMst = [];
    let listMumber1 =
        {id: '1', cd: '5160', cdName: '広島北'};
    listZigyojoMst.push(listMumber1);
    let listMumber2 =
        {id: '2', cd: '6120', cdName: '山口'};
    listZigyojoMst.push(listMumber2);

    this.setState({
      seiHeaderDate: data,
      listZigyojoMst: listZigyojoMst,
    });
    // } else {
    //   sysErr(this.props);
    // }
  };

  /**
   * 画面項目初期化
   * @param {object} flex
   */
  initializedGrid(flex) {
    flex.columnFooters.rows.push(new CustomFlexGrid.GroupRow());
    flex.bottomLeftCells.setCellData(0, 0, 'Σ');
  }

  /**
   * 画面項目初期化
   * @param {object} initItems
   */
  initializeItems = (initItems) => {
    const gmnItems = Object.assign(
        gmnItemsNyuryo,
    );
    for (const key of Object.keys(gmnItems)) {
      const item = gmnItems[key];
      if (Object.hasOwn(item, 'binding')) {
        initItems[item.binding] = null;
      }
    }
  };

  // /**
  //  * 画面項目設定
  //  */
  // setGridItems = () => {
  //   for (const key of Object.keys(gridViews)) {
  //     this._gridItems[key] = {...gridViews[key]};
  //     this._fields.push(this._gridItems[key].binding);
  //     if (this._gridItems[key].isPopup) {
  //       this._gridItems[key].initializedPopup =
  //           this.initializePopupItems.bind(this, this._gridItems[key].binding);
  //     }
  //   }
  // };

  /**
     * 編集ダイアログ
     * @param {string} name
     * @param {*} ctl
     */
  initializePopupItems(name, ctl) {
    this.popupItems[name] = ctl;
  }

  /**
     * 初期値設定
     */
  setInitValue = () => {
    for (const key of Object.keys(this._gridItems)) {
      let initValue = null;
      this.items[this._gridItems[key].binding] = initValue;
      if (this._gridItems[key].isPopup) {
        this.popupItems[this._gridItems[key].binding] = initValue;
      }
    }
  };

  /**
   * コンボリスト作成
   * @param {array} itemsList
   * @param {string} label
   * @param {array} comboList
   */
  setComboList = (itemsList, label, comboList) => {
    const index = this.findIndex(itemsList, label);
    if (index !== -1) {
      itemsList[index].selections = comboList;
    }
  };

  /**
   * 配列検索
   * @param {array} list
   * @param {string} label
   * @return {number} インデックス
   */
  findIndex = (list, label) => {
    return list.findIndex((element) => {
      return element.label === label;
    });
  };

  /**
   * 登録
   */
  doCreate = async () => {
  };

  /**
   * 取下げ
   */
  doWithdraw = async () => {
  };

  /**
   * 操作ボタン生成
   * @return {*}
   */
  createBtnProps() {
    const {handleSubmit} = this.props;

    let btnProps = [];
    const btnCreate = {type: 'positive', key: 'SCA1002Create', label: '行追加', click: handleSubmit(this.doCreate)};
    const btnWithdraw = {type: 'positive', key: 'SCA1002Withdraw', label: '行削除', click: handleSubmit(this.doWithdraw)};

    btnProps.push(btnCreate, btnWithdraw);


    return btnProps;
  }

  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      isReadOnly={view.readOnly}/>;
  };

  /**
   * 一覧パーツ取得 調査機関事業所
   * @param {*} view 設定
   * @param {*} readOnly 画面モード
   * @return {*} 一覧パーツ
   */
  getComboTskkJgyosyoList = (view, readOnly) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      width={view.width}
      dataMap={new DataMap(this.state.tskkJgyosyoList, 'id', 'name')}
      editor={new AutoComplete(document.createElement('div'), {
        itemsSource: this.state.tskkJgyosyoList,
        selectedValuePath: 'id',
        displayMemberPath: 'name',
      })}
      isReadOnly={readOnly}/>;
  };

  /**
   * 一覧パーツ取得 担当者
   * @param {*} view 設定
   * @param {*} readOnly 画面モード
   * @return {*} 一覧パーツ
   */
  getComboUserIdList = (view, readOnly) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      width={view.width}
      dataMap={new DataMap(this.state.userIdList, 'id', 'name')}
      editor={new AutoComplete(document.createElement('div'), {
        itemsSource: this.state.userIdList,
        selectedValuePath: 'id',
        displayMemberPath: 'name',
      })}
      isReadOnly={readOnly}/>;
  };

  /**
   * 一覧パーツ取得 実施年月
   * @param {*} view 設定
   * @param {*} readOnly 画面モード
   * @return {*} 一覧パーツ
   */
  getComboYearMonthList = (view, readOnly) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      width={view.width}
      dataMap={new DataMap(this.state.yearMonthList, 'id', 'name')}
      editor={new AutoComplete(document.createElement('div'), {
        itemsSource: this.state.yearMonthList,
        selectedValuePath: 'id',
        displayMemberPath: 'name',
      })}
      isReadOnly={readOnly}/>;
  };

  /**
   * 一覧描画
   * @return {*}
   */
  renderTable() {
    const props = {
      filterOn: true,
      exceptFilters: exceptFiltersBindings,
      rowHeaderType: 'none',
      headersVisibility: 'Column',
      frozenColumns: 7,
      isReadOnly: false,
      validateEdits: false,
      doShowMessage: this.props.doShowMessage,
      initItems: this.items,
      trackChanges: true,
      // screenId: 'BFE20104G',
      style: {maxHeight: '570px', height: 'auto', width: 'auto'},
      formatItemFunction: this.onFormatItemHandler,
    };
    let viewElems = [];
    // if (getListViews) {
    //   for (const view of getListViews) {
    //     let viewElem;
    //     if (view.dataType === 'header') {
    //       let viewGroups = [];
    //       for (const elem of view.elems) {
    //         if (elem.dataType === 'Select') {
    //           switch (view.binding) {
    //             case 'ereryYearZisiMonth':
    //               viewGroups.push(this.getComboYearMonthList(elem, false));
    //               break;
    //             case 'fourYearZisiMonth':
    //               viewGroups.push(this.getComboYearMonthList(elem, false));
    //               break;
    //             default:
    //               viewGroups.push(this.getComboYearMonthList(elem, false));
    //           }
    //         } else {
    //           viewGroups.push(this.getViewElem(elem));
    //         }
    //       }
    //       viewElem = <FlexGridColumnGroup header={view.header}>
    //         {viewGroups}
    //       </FlexGridColumnGroup>;
    //     } else if (view.dataType === 'Select') {
    //       switch (view.binding) {
    //         case 'tskkJgyosyo':
    //           viewElem = this.getComboTskkJgyosyoList(view, false);
    //           break;
    //         case 'userId':
    //           viewElem = this.getComboUserIdList(view, false);
    //           break;
    //         default:
    //           viewElem = this.getComboTskkJgyosyoList(view, false);
    //       }
    //     } else {
    //       viewElem = this.getViewElem(view);
    //     }
    //     viewElems.push(viewElem);
    //   }
    // }


    if (getListViews) {
      for (const view of getListViews) {
        const header = view.header;
        if (!header) {
          continue;
        }
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            let secondViewElem;
            let thirdViewGElem;
            // 2層ヘッダー処理
            if (elem.dataType === 'header') {
              let secondViewGroups = [];
              for (const secondElem of elem.elems) {
                if (secondElem.dataType === 'header') {
                  let thirdViewGroups = [];
                  for (const thirdElem of secondElem.elems) {
                    thirdViewGroups.push(this.getViewElem(thirdElem));
                  }
                  thirdViewGElem =
                    <FlexGridColumnGroup header={secondElem.header}>
                      {thirdViewGroups}
                    </FlexGridColumnGroup>;
                  secondViewGroups.push(thirdViewGElem);
                } else {
                  secondViewGroups.push(this.getViewElem(secondElem));
                }
              }
              secondViewElem = <FlexGridColumnGroup header={elem.header}>
                {secondViewGroups}
              </FlexGridColumnGroup>;
              viewGroups.push(secondViewElem);
            } else {
              if (elem.dataType === 'Select') {
                switch (view.binding) {
                  case 'ereryYearZisiMonth':
                    viewGroups.push(this.getComboYearMonthList(elem, false));
                    break;
                  case 'fourYearZisiMonth':
                    viewGroups.push(this.getComboYearMonthList(elem, false));
                    break;
                  default:
                    viewGroups.push(this.getComboYearMonthList(elem, false));
                }
              } else {
                viewGroups.push(this.getViewElem(elem));
              }
              // viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          switch (view.binding) {
            case 'tskkJgyosyo':
              viewElem = this.getComboTskkJgyosyoList(view, false);
              break;
            case 'userId':
              viewElem = this.getComboUserIdList(view, false);
              break;
            default:
              viewElem = this.getComboTskkJgyosyoList(view, false);
          }
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }


    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * 合計一覧描画
   * @return {*}
   */
  renderTotalTable() {
    const props = {
      rowHeaderType: 'None',
      id: 'SCE1002HenkomaeTable',
      filterOn: true,
      headersVisibility: 'None',
      allowDragging: 'Columns',
      style: {height: 'auto', maxHeight: '300px', width: 'auto'},
      isReadOnly: false,
      screenId: 'SCE1002Henkomae',
      checkedFunction: this.checkStateUpdate,
      doShowMessage: this.props.doShowMessage,
      validateEdits: false,
      // DeleteOn: true,
      getError: this.getError,
    };
    // 一覧定義取得
    let viewElems = [];
    if (totalViews) {
      for (const view of totalViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              viewGroups.push(this.getViewElemComboBox(elem, false));
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      // <CustomFlexGrid frozenRows={1} ref={this.gridRef} {...props}>
      <CustomFlexGrid ref={this.gridTotalRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * 年度計画登録画面の入力チェック
   * @param {object} item 検証行データ
   * @param {string} prop binding
   * @param {boolean} parsing 予期されたデータ型に解析できない値を入力したかどうか
   * @return {string} 結果
   */
  getError = (item, prop, parsing) => {
    if (parsing) {
      return null;
    }
    if (prop == 'henkoGo' && item.henkoGo == '') {
      return this.props.getMessage('BFY000017E', ['変更後', item.rowId + '行目']);
    }
    if (prop == 'jikai' && item.jikai == '') {
      return this.props.getMessage('BFY000017E', ['次回', item.rowId + '行目']);
    }
  };


  /**
   * 一覧に変更があるかチェックする
   * @return {bool} true: 変更あり
   */
  doCheckModified = () => {
    let result = false;
    if (this.gridRef.current) {
      result = this.gridRef.current.commitAndCheck();
    }
    return result;
  };

  // /**
  //  * リンクの別タブで画面遷移
  //  * @param  {*} e
  //  */
  // handleLinkClick = (e) => {
  //   e.preventDefault();
  //   const _data = this.state.seikyuInfo;
  //   // BFE10101G_請求一覧に遷移
  //   setSessionObject(
  //       GMN.BFE10101G.id,
  //       this.setParam('', _data),
  //   );
  //   window.open('/BFE10101G', '_blank');
  // };

  /**
   * パラメータ設定
   * @param {*} list パラメータリスト
   * @param {*} data データ
   * @return {*} パラメータ
   */
  setParam = (list, data) =>{
    let _param = {};
    list.forEach((key) => {
      if (Object.hasOwn(data, key)) {
        _param[key] = data[key];
      }
    });
    return _param;
  };

  /**
   * 終了処理
   */
  async componentWillUnmount() {
    this.props.doSetInitValues(null);
  }

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
          this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        // action: () => {
        //   this.props.history.push('/login');
        // },
      });
    }
  };

  doInterimSave = () => {
    let values = this.props.values;
    let _warningMessages = [];
    this.setState({
      warningMessages: _warningMessages,
    });

    if (values.sinseiId == '') {
      let message = {
        id: 'BFY000017E',
        values: ['申請番号', ''],
      };
      _warningMessages.push(message);
    }
    if (values.zigyoujo == '') {
      let message = {
        id: 'BFY000017E',
        values: ['NW事業所', ''],
      };
      _warningMessages.push(message);
    }
    if (values.sakuseiDate == '') {
      let message = {
        id: 'BFY000017E',
        values: ['作成日', ''],
      };
      _warningMessages.push(message);
    }

    let tebleData = this.gridRef.current.grid.rows.length;
    for (let i = 0; i < tebleData; i++ ) {
      let a = this.gridRef.current.grid.rows[i].dataItem;
      if (a.henkoGo == '') {
        let message = {
          id: 'BFY000017E',
          values: ['変更後', a.rowId + '行目'],
        };
        _warningMessages.push(message);
      }
      if (a.jikai == '') {
        let message = {
          id: 'BFY000017E',
          values: ['次回', a.rowId + '行目'],
        };
        _warningMessages.push(message);
      }
    }

    if (_warningMessages.length > 0) {
      this.setState({
        warningMessages: _warningMessages,
      });
      return;
    } else {
      this.props.doShowMessage({
        message: {
          id: 'BFY000009I',
          values: ['一時保存'],
        },
      });
    }
  };

  doSyoninShinsei = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['承認申請'],
      },
    });
  };

  // doFullDelete = () => {
  //   this.props.doShowMessage({
  //     message: {
  //       id: 'BFY000009I',
  //       values: ['取止め'],
  //     },
  //   });
  // };

  doApprove = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['承認'],
      },
    });
  };

  doRemand = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['差戻'],
      },
    });
  };

  /**
   * 追加ボタン押下時
   */
  doAdd = () => {
    let data = this.props.values;
    this.setState({modalOpen: true, gamenData: data});
  };

  doClose = () => {
    // 請求情報データを画面に設定
    let data = this.state.gamenData;
    this.props.doSetInitValues(data);
    this.setState({modalOpen: false});
  };

  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="zigyoujo" item xs={12} sm={2}>
            <Field
              id="zigyoujo"
              name="zigyoujo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="NW事業所"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北'}</MenuItem>
              {/* <MenuItem value={6120}>{'山口'}</MenuItem> */}
            </Field>
          </Grid>
          <Grid key="zigyoujoBefore" item xs={12} sm={2}>
            <Field
              id="zigyoujoBefore"
              name="zigyoujoBefore"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="旧NW事業所"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北'}</MenuItem>
              <MenuItem value={5170}>{'廿日市'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tyousakikan" item xs={12} sm={2}>
            <Field
              id="tyousakikan"
              name="tyousakikan"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査会社"
              type="text"
              fullWidth
              required={true}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={3000}>{'保安協会'}</MenuItem>
              <MenuItem value={5000}>{'工業組合'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tskkJgyosyo" item xs={12} sm={2}>
            <Field
              id="tskkJgyosyo"
              name="tskkJgyosyo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査機関事業所"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={4500}>{'広島支'}</MenuItem>
              <MenuItem value={4510}>{'福山支'}</MenuItem>
              <MenuItem value={4520}>{'尾道支'}</MenuItem>
              <MenuItem value={4530}>{'三次支'}</MenuItem>
              <MenuItem value={4540}>{'呉支'}</MenuItem>
              <MenuItem value={4550}>{'竹原支'}</MenuItem>
              <MenuItem value={4580}>{'府中支'}</MenuItem>
              <MenuItem value={4590}>{'東広島支'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="blockNo" item xs={12} sm={4}>
            <Field
              id="blockNoFrom"
              name="blockNoFrom"
              label="ブロック番号"
              component={renderTextField}
              className="fields"
              type="text"
              sx={{width: '40%'}}
              InputProps={{
                readOnly: false,
              }}
            />
            <span className="wave">～</span>
            <Field
              id="blockNoTo"
              name="blockNoTo"
              label={<React.Fragment />}
              component={renderTextField}
              className="fields"
              type="text"
              sx={{width: '40%'}}
              InputProps={{
                readOnly: false,
              }}
            />
          </Grid>

        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="tdhknAddCd" item xs={12} sm={6}>
            <Field
              id="tdhknAddCd"
              name="tdhknAddCd"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="都道府県"
              type="text"
              sx={{width: '20%'}}
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={31}>{'鳥取県'}</MenuItem>
              <MenuItem value={32}>{'島根県'}</MenuItem>
              <MenuItem value={33}>{'岡山県'}</MenuItem>
              <MenuItem value={34}>{'広島県'}</MenuItem>
              <MenuItem value={35}>{'山口県'}</MenuItem>
            </Field>

            <Field
              id="azatmApart"
              name="azatmApart"
              // variant="standard"
              component={renderTextField}
              // className="fields"
              label="住所"
              sx={{width: '75%'}}
              type="text"
              required={false}
              InputProps={{
                readOnly: false,
              }}
            />
          </Grid>
          <Grid key="states" item xs={12} sm={2} >
            <Field
              id="states"
              name=""
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="ステータス"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={10}>{'作成中'}</MenuItem>
              <MenuItem value={40}>{'報告中'}</MenuItem>
              <MenuItem value={50}>{'確認中'}</MenuItem>
              <MenuItem value={60}>{'承認中'}</MenuItem>
              <MenuItem value={90}>{'完了'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="everyYearTs" item xs={12} sm={2}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="everyYearTs"
                  name="everyYearTs"
                  component={renderCheckbox}
                  label="毎年調査"
                  onChange={this._handleChangeCheckbox}
                  // isChecked="true"
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid key="noSettingTs" item xs={12} sm={2}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="noSettingTs"
                  name="noSettingTs"
                  component={renderCheckbox}
                  label="未設定のみ"
                  onChange={this._handleChangeCheckbox}
                  // isChecked="true"
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid key="key1001CreateSen1" item>
          <PositiveButton
            id="btn1001CreateSen1"
            onClick={this.doInterimSave}
            variant="contained"
            startIcon={<SaveAltIcon />}
            // size="large"
          >
            <span>一時保存</span>
          </PositiveButton>
        </Grid>
      </Grid>
    );
  };

  /**
   * 承認状況画面の表示
   */
  displayApproval = () => {
    this.setState({
      showApprovalModal: true,
    });
  };

  /**
* 承認状況画面画面を閉じる
*/
  closeApproval = () => {
    this.setState({
      showApprovalModal: false,
    });
  };

  /**
   * 画面描画
   * @return {*}
   */
  render() {
    const {
      // classes,
      // generalPurposeMap,
      // reset,
      // handleSubmit,
      // values,
      userInfo,
    } = this.props;
    // const {userInfo} = this.props;
    // let itemListNyuryo = createFieldItems(gmnItemsNyuryo);
    let itemListStepApproval = createFieldItems(gmnItemsStepApproval);
    // // ボタン
    // const _btnProps = this.createBtnProps();

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    return (
      <form noValidate autoComplete="off" className="form_root">
        <MainContainer
          props={this.props}
          ActorName={userInfo.ActorName}
          footerBtn={footerBtn}
        >
          {this.state.visableSnFlg &&
            <Approval props={this.props}
              approve={this.doApprove} sasimodosi={this.doRemand}/>}
          <Grid key="keySCA1002Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={transitionList}/>
          <PaperPart>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="search" item xs={12}>
                <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true}/>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className="button_list"
                  size="middle"
                  // onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  size="middle"
                  // onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          {this.state.visableSlFlg &&
            <span>
              <PaperPart>
                <Typography variant="h6" gutterBottom>否決</Typography>
                {createGridFields(GMN.ANNUAL_SURVERY_PLAN_INFO.id,
                    itemListStepApproval)}
              </PaperPart>
            </span>
          }
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            direction={'row'}
          >
            {this.renderTable()}
          </Grid>

        </MainContainer>
        <ApprovalStatus
          openState={this.state.showApprovalModal}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.displayApprovalModal}
          handleClose = {this.closeApproval}/>
      </form>
    );
  }
}

const FORM_NAME = 'SCA1002FORM';
Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
    syncWarnings: getFormSyncWarnings(FORM_NAME)(state),
  };
})(Container));

Container.propTypes = {
  classes: PropTypes.object,
  userInfo: PropTypes.object,
  values: PropTypes.object,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
  title: PropTypes.string,
  genericMap: PropTypes.object,
  getMessage: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    userInfo: state.auth.userInfo,
    initialValues: state.common.setInitValues,
    genericMap: state.common.generalPurposeMap,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doSetInitValues: commonOperations.doSetInitValues,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withFormatMessage(withMediaQuery()(Container))));
